export const handleSalaryInput = (event: React.ChangeEvent<HTMLInputElement>): number | null => {
  const inputValue = event.target.value;
  const filteredValue = inputValue?.replace(/[,.]/g, "");
  const numericValue: number = filteredValue ? parseInt(filteredValue, 10) : 0;
  return numericValue;
};
